exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-4b8ad2a7] {\n  margin: 28px 0 24px 0;\n  align-self: flex-start;\n}\n.empty-wrapper[data-v-4b8ad2a7] {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.new-region-wrapper[data-v-4b8ad2a7] {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n}", ""]);

// exports
